import React, { Component } from 'react';
import './treeview.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as repositoryActions from '../../../Store/Actions/repositoryActions';
import * as globalActions from '../../../Store/Actions/globalActions';
import { connect } from 'react-redux';
//import { layer } from '@fortawesome/fontawesome-svg-core';
//import InputMask from 'react-input-mask';



class TreeView extends Component {
    constructor(props) {
      super(props);
      // PROPS
      /*
        --config={color:"#aad",readOnly:false/true, maxLength:0, textAlign:"left/center/right"}
          // color = hexa color for CSS text
          // readOnly = bool remove input to a read only textbox
          // maxlength = char max, if 0 no limit
          // textAlign = how to handle text position
        --updateValue  //callbackMethod
      */
        this.state = {
          nodes:[],
          globalId:0,
          currentNode:null,
        };

        

  }

  // INNER METHOD
  toggleNode = (nodeGlobalId) => {
    var nodes = this.state.nodes;
    nodes = this.recursiveToggleNode(nodeGlobalId,nodes);
    this.setState({nodes:nodes});
   
  }

  recursiveToggleNode = (nodeGlobalId,nodes)=>{
    nodes = nodes.map((node,i)=>{
      if(node.children.length>0){
        node.children = this.recursiveToggleNode(nodeGlobalId,node.children);
      }
      if(node.globalId === nodeGlobalId){
        node.isOpen = node.isOpen?false:true;
      }
      return node
    });
    return nodes;
  }

  selectNode = (nodeGlobalId,node) => {
    var nodes = this.state.nodes;
    this.props.clean_loaded_object();
    //this.props.resetPage();
    
    this.props._setCurrentNode(node);
    setTimeout(this.props.getDataSet(node,true), 1000);
    
    nodes = this.recursiveSelectNode(nodeGlobalId,nodes);
    this.setState({nodes:nodes,currentNode:node});
   
  }

  recursiveSelectNode = (nodeGlobalId,nodes)=>{
    nodes = nodes.map((node,i)=>{
      if(node.children.length>0){
        node.children = this.recursiveSelectNode(nodeGlobalId,node.children);
      }
      if(node.globalId === nodeGlobalId){
        node.isActive = true;
      }else{
        node.isActive = false;
      }
      return node
    });
    return nodes;
  }
  
  recursiveTransformNode = (nodes) =>{

    nodes = nodes.map((node,i)=>{
      node.isOpen = false;
      node.isActive = false;
      node.globalId = this.state.globalId++;
      
      if(node.children.length > 0){
        node.children = this.recursiveTransformNode(node.children);
      }

      return node
    });
    return nodes
  }

  // BUILDING METHOD
  componentDidMount = () =>{
    var nodes = this.props.nodes;
    // ADD PARAM TO NODE isOpen / globalId
    nodes = this.recursiveTransformNode(nodes,this.state.globalId);
    this.setState({nodes:nodes});
  }
  
  buildContent = () =>{
    var treeviewList = null;
    treeviewList = this.state.nodes.map((node,i)=>{
      return this.buildNodeElement(node,i);
    });

    return treeviewList
  }

  buildNodeElement = (node,i) =>{
    var subLevel = null;

    if(node.children.length > 0 && node.isOpen){
      subLevel = node.children.map(
        (node,j)=>{
          return this.buildNodeElement(node,j);
        }); 
    }


    return (
      <div className={node.isOpen?"treeLine active":"treeLine"}  key={i}>
        <div className={node.isActive?"line-header active":"line-header"} onDoubleClick={this.toggleNode.bind(this,node.globalId)}>{node.children.length===0?<i> - </i>:<FontAwesomeIcon onClick={this.toggleNode.bind(this,node.globalId)} icon={node.isOpen?"minus-square":"plus-square"} />} <span onClick={this.selectNode.bind(this,node.globalId,node)}>{node.name}</span></div>
          <div className="child-content">
            {subLevel}
          </div>
      </div>
    )
  }

  // ---------------------RENDER --------------------- 
  render() {
    var treeviewList = this.buildContent();
    

    return (
          <div className={"treeview"} >
            {treeviewList}
            
          </div>
    );
  }
}
  
  const mapStateToProps = (state) => {    
    return {  
      _currentNode:state.appReducer.currentNode,
      //pageNumber:state.apiReducer.pageNumber,
    } 
  }
  const mapDispatchToProps = (dispatch) => {
    return {
      _setCurrentNode:(node) => dispatch(globalActions.setCurrentNode(node)),
      clean_loaded_object: () => dispatch(repositoryActions.clean_loaded_object()),
    } 
  } 
  
  export default connect(mapStateToProps, mapDispatchToProps)(TreeView);
  